import { memo, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Popup } from "react-mapbox-gl";
import { makeStyles } from "@mui/styles";

import {
  isZoomingSelector,
  popupDetailsSelector,
  lastPopupDetailsSelector,
} from "../../../reducers/map/selectors";
import {
  isEditOneModeSelector,
  pickupConfigForPostcodeSelector,
  pickupVolumesSelector,
} from "../../../reducers/matrixProfile/selectors";

import { View } from "../../View";
import { RouteLabel } from "./RouteLabel";
import { PickupVolumes } from "./PickupVolumes";

const useStyles = makeStyles({
  root: {
    zIndex: "50 !important",
  },
  routeContainer: {
    display: "flex",
    padding: "2px",
  },
});

export const PickupLabelPopUp = memo(({ setPopupDetailsFromCords }) => {
  const styles = useStyles();

  const isEditOneMode = useSelector(isEditOneModeSelector);
  const pickupVolumes = useSelector(pickupVolumesSelector);
  const { coordinates = [0, 0], postcode } =
    useSelector(popupDetailsSelector) || {};
  const { point: lastPoint, coordinates: lastCoordinates } =
    useSelector(lastPopupDetailsSelector) || {};
  const isZooming = useSelector(isZoomingSelector);
  const pickupConfig = useSelector(
    pickupConfigForPostcodeSelector(postcode)
  ) || { routeCodes: [] };
  const [prevIsZooming, setPrevIsZooming] = useState();
  const isEditWithOverlay = isEditOneMode && !!pickupVolumes;

  useEffect(() => {
    if (isZooming === prevIsZooming) return;
    setPrevIsZooming(isZooming);
    isEditWithOverlay &&
      lastPoint &&
      setPopupDetailsFromCords({
        point: lastPoint,
        lngLat: {
          lng: lastCoordinates[0],
          lat: lastCoordinates[1],
        },
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isZooming, prevIsZooming, lastPoint, lastCoordinates, isEditWithOverlay]);

  if (!coordinates || !isEditWithOverlay) return null;

  const routesWithVolume = pickupConfig.routeCodes.filter(
    (routeCode) => !!pickupVolumes?.[routeCode]?.[postcode]
  );

  return (
    <Popup
      coordinates={coordinates}
      anchor={"top-left"}
      offset={[0, 10]}
      className={styles.root}
    >
      {(routesWithVolume.length ? routesWithVolume : [null]).map(
        (routeCode, index) => (
          <View key={index} className={styles.routeContainer}>
            <RouteLabel routeCode={routeCode} />
            <PickupVolumes
              routeCode={routeCode}
              postcode={postcode}
              pickupConfig={pickupConfig}
              showNoVolume={true}
            />
          </View>
        )
      )}
    </Popup>
  );
});
